<template>
    <div class="main-con">
        <table class="data-table">
            <thead style="z-index: 1">
                <tr>
                    <th @click="sortOptionChange('supportedPrinterSeriesId','number')" class="width-pixel-50" >ID</th>
                    <th @click="sortOptionChange('manufactorName')" class="width-percent-10">제조사</th>
                    <th @click="sortOptionChange('seriesName')" class="width-percent-10">대표 모델</th>
                    <th @click="sortOptionChange('supportModel')">지원 모델</th>
                    <th class="width-pixel-70">모델 추가</th>
                    <th @click="sortOptionChange('supportModelYn')"  class="width-pixel-50">모두 지원</th>
                    <th @click="sortOptionChange('command')"  class="width-pixel-70">명령어 종류</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in whatTableData" :key="index">
                    <td>{{ item.supportedPrinterSeriesId }}</td>
                    <td :title="item.manufactorName" class="column-size-short">{{ item.manufactorName }}</td>
                    <td :title="item.seriesName" class="column-size-short">{{ item.seriesName }}</td>
                    <td :title="item.supportModel" class="column-size-short">{{ item.supportModel }}</td>
                    <td>
                        <v-btn
                            color="primary"
                            dark
                            x-small
                            @click.stop="openModal(item)"
                        >
                            모델추가
                        </v-btn>
                    </td>
                    <td>{{ item.supportModelYn }}</td>
                    <td :title="item.command" class="column-size-short column-center-align">{{ item.command }}</td>
                </tr>
            </tbody>
        </table>
        <printer-series-model-modal :dialog="dialog"
                                    :tab-number="tabNumber"
                                    :is-dirty-check="isDirtyCheck"
                                    :origin-support-model="originSupportModel"
                                    :modify-support-model="modifySupportModel"
                                    @change-support-model="changeSupportModel"
                                    @complete-button-click="completeButtonClick"
                                    @close-modal="closeModal"
        />
    </div>

</template>

<script>
/**
 * 프린트 시리즈에대한 테이블입니다.
 * SupportModel로 원본과 수정본의 비교로 dirtyCheck를 합니다.
 *
 */
import PrinterSeriesModelModal from "@/views/monitoring/printerSeries/PrinterSeriesModelModal";

export default {
    name: "NoLibraryBagicTable",
    components: {
        PrinterSeriesModelModal
    },
    data() {
        return {
            choicePrinterSeriesId:undefined,//모델추가를 클릭한 칼럼의 serialId를 저장합니다.
            sortOption: {
                sortName: null,
                sortOrder: 1,
            },
            dialog:false,//모달을 컨트롤 하기위해 사용됩니다.
            originSupportModel:{//원본 supportModel입니다
                versionOne:undefined,
                versionTwo:undefined
            },
            modifySupportModel:{//수정한 supportModel입니다.
                versionOne:undefined,
                versionTwo:undefined
            },
            isDirtyCheck:{//원본데이터랑 다른경우 체크할때 사용합니다. false 일 경우가 수정된 경우 입니다.
                versionOne:true,
                versionTwo:true
            },
            innerTableData:{
                versionOne:[],
                versionTwo:[]
            }
        }
    },
    props :{
        tabNumber:{ //0은 V1 1는 V2
            type:Number,
            default:0
        },
        tableBodyData:{//선택된 tab과 선택되지 않는 탭의 데이터입니다.
            type:Object,
            default:()=>{}
        }
    },
    computed: {
        /**
         * 선택된 탭의 데이터를 가져와서 테이블에 뿌립니다.
         * @returns {*}
         */
        whatTableData() {
            const whatVersionData=!this.tabNumber?'versionOne':'versionTwo'
            return this.tableBodyData[whatVersionData]
        }
    },
    methods: {
        /**
         * modifySupportModel을 바꾸기 위한 함수입니다.
         * @param newValue
         */
        changeSupportModel(newValue) {
            this.dirtyCheck(newValue)
            this.modifySupportModel= newValue
        },
        /**
         * DirtyCheck 하는 함수입니다.
         * originSupportModel(원본) 과 modifySupportModel(수정본)을 비교하여
         * 수정사항이 있는지 체크합니다.
         *
         */
        dirtyCheck(modifySupportModel){
            const versionOne=modifySupportModel.versionOne === this.originSupportModel.versionOne
            const versionTwo=modifySupportModel.versionTwo === this.originSupportModel.versionTwo
            this.isDirtyCheck={ versionOne, versionTwo }
        },

        /**
         * 작성하기 버튼을 클릭했을때 동작하는 함수입니다.
         * 해당 프린터의 인자와 수정할한 supportModel을 emit으로 넘겨줍니다.
         * @param whatTabNumber
         */
        completeButtonClick(whatTabNumber){
            const whatVersionData=!whatTabNumber?'versionOne':'versionTwo'
            const supportedPrinter = this.findPrintData(this.choicePrinterSeriesId,whatVersionData)
            this.$emit(
                "complete-button-click",
                whatTabNumber,
                this.modifySupportModel[whatVersionData],
                supportedPrinter,
            )
        },
        /**
         * id를 인자로 받아서 해당 printData를 찾는 함수입니다.
         * completeButtonClick,openModal 2개의 함수에서 쓰입니다.
         * @param id
         * @returns {*}
         */
        findPrintData(id,whatVersionData) {
            const tableData = this.tableBodyData[whatVersionData]
            const findPrintData = tableData.find(({supportedPrinterSeriesId}) => {
                return supportedPrinterSeriesId===id
            })
            return findPrintData
        },
        /**
         * 모델 추가 버튼을 클릭했을때 작동합니다
         * 각각 원본값(originSupportModel) 수정값(modifySupportModel)에 저장하는데
         * 각각 저장하는 경우가 2가지로 나뉩니다.
         * 1. 선택되있는 탭 : 테이블에 내용을 그대로 가져옵니다.
         * 2. 선택되지 않은 탭 : 선택되있는 탭의 id와 비교후 같은 id의 내용을 가져옵니다.
         */
        openModal(item) {
            const {supportedPrinterSeriesId, supportModel} = item
            const whatVersionData=!!this.tabNumber?'versionOne':'versionTwo'
            const printData = this.findPrintData(supportedPrinterSeriesId,whatVersionData)
            const noneChoiceModel = printData && printData.supportModel
            const supportModelValue={
                versionOne: !this.tabNumber?supportModel:noneChoiceModel,
                versionTwo: !!this.tabNumber?supportModel:noneChoiceModel,
            }
            this.originSupportModel={...supportModelValue}
            this.modifySupportModel={...supportModelValue}
            this.dialog = true
            this.choicePrinterSeriesId=supportedPrinterSeriesId
        },

        /**
         * 모달을 닫을때 기본적인 정보는 초기화 됩니다.
         */
        closeModal(){
            this.dialog=false
            const initSupportModel = {
                versionOne:undefined,
                versionTwo:undefined
            }
            this.isDirtyCheck={
                versionOne:true,
                versionTwo: true
            }
            this.modifySupportModel={...initSupportModel}
            this.originSupportModel={...initSupportModel}
            this.choicePrinterSeriesId=undefined
        },
        /**
         * header를 누를때 동작합니다.
         * 먼저 sortOption을 세팅하고 그에 맞게 sorting 해줍니다.
         * 숫자랑 문자 다 가능합니다.
         *
         */
        sortOptionChange(e,type) {
            this.setSortOption(e);
            this.$emit("sort-option-change",e,this.sortOption,type)
        },

        initSort(){
            this.sortOption = {
                sortName: null,
                sortOrder: 1,
            }
        },
        setSortOption(e) {
            if (e === this.sortOption.sortName){
                this.sortOption.sortOrder *= -1
            } else {
                this.sortOption = {
                    sortName: e,
                    sortOrder: 1,
                }
            }
        },

    },
    mounted() {
        this.initSort()
    }
}
</script>

<style scoped>

>>> input[type=checkbox] {
    position: absolute;
}

.main-con{
    height: 93%; /*100%로 하면 하단에 열이 3개정도 짤립니다.*/
    overflow-y: auto;
}
.main-con .data-table{
    table-layout: fixed;
    border-spacing: 0;
    width: 100%;
    overflow-x: auto;
}
.main-con .data-table thead{
    position: sticky;
    top: 0;
    background: #ddd;
}
.main-con .data-table thead tr th {
    font-size: 11px;
    padding-right: 8px;
}

.main-con .data-table tbody td{
    text-align: left;
    border: 1px solid #ccc;
    font-size: 11px;
    padding: 0.15rem;
}

.main-con .data-table tbody tr:nth-child(even){
    background: #f5f5f5;
}
.main-con .data-table tbody tr:hover{
    background: #ddd;
}
.column-size-short{
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
}
.button-flex-left{
    display: flex;
    justify-content: space-between;
}
.column-size-short{
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
}
.width-pixel-50{
    width: 50px !important;
}
.width-pixel-70{
    width: 70px !important;
}
.width-percent-10{
    width: 10% !important;
}
.column-center-align{
    text-align: center !important;
}
</style>
